import * as React from 'react'

function SvgAccessInfoIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.301 3.699a5.802 5.802 0 00-9.29 6.696l-9.006 9.003L2 21.994 7.036 22v-2.449h2.449v-2.448h2.45v-2.449l1.667-1.668a5.804 5.804 0 006.699-1.086 5.798 5.798 0 000-8.201zm-1.844 4.323a1.754 1.754 0 11-2.48-2.482 1.754 1.754 0 012.48 2.482z"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgAccessInfoIcon
